import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

// import { Router, Routes } from "@angular/router";
// import { LoginService } from "./app/common/services/login.service";



// console.log("RedirectorComponent: ", RedirectorComponent)

if (environment.production && !environment.enableLogs) {
  if (localStorage.getItem('DEBUGPROD') === '1') {
    console.log('PRODUCTION MODE + OPEN CONSOLE LOGS')
  } else {
    ['log', 'debug', 'info', 'warn'].forEach((method) => {
      ;(window.console as unknown as Record<string, () => void>)[method] = () => {
      }
    })
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.log('zone-error')
    // console.error(err)
  })

